import React, { useEffect } from 'react'
import { churchConnectAccountCheck, setstartCreatingAccount } from 'features/giving/givingSlice'
import { useDispatch, useSelector } from 'react-redux'
import { SettingsMainContainer, TopHeaderSettings } from '../settings.styled'
import Loader from 'loaders/Loader'
import ChurchConnectAccount from './ChurchConnectAccount'
import styled from 'styled-components'
import CreateConnectAcctForm from './CreateConnectAcctForm'

import { useTranslation } from 'react-i18next'

export default function Giving() {
  const { t: translate } = useTranslation()
    const dispatch = useDispatch()
    const { user } = useSelector(state => state.auth)
    const {
        startCreatingAccount,
        churchConnectAccountCheckLoading,
        churchConnectAccountCheckSuccess,
        churchConnectAccountCheckError,
        churchConnectAccountCheckMessage,
    } = useSelector(state => state.giving)

    useEffect(() => {
        dispatch(churchConnectAccountCheck())
    }, [dispatch, startCreatingAccount])

    if (churchConnectAccountCheckLoading) {
        return (
            <SettingsMainContainer>
                <TopHeaderSettings>
                    {translate("web:givingSettings.memberGiving")}
                </TopHeaderSettings>
                <LoadingWrap>
                    <Loader />
                </LoadingWrap>
            </SettingsMainContainer>
        )
    }

    return (
        <SettingsMainContainer>
            <TopHeaderSettings>
                {translate("web:givingSettings.memberGiving")}
            </TopHeaderSettings>

            {churchConnectAccountCheckSuccess ? (
                <ChurchConnectAccount />
            ) : startCreatingAccount ? (
                <CreateConnectAcctForm />
            ) : churchConnectAccountCheckError && (
                churchConnectAccountCheckMessage === 'Not premium' ? (
                    <StatusCard>
                        <StatusTitle>{translate('giving:admin.premiumRequired')}</StatusTitle>
                        <StatusCopy>{translate('giving:admin.premiumBody')}</StatusCopy>
                    </StatusCard>
                ) : churchConnectAccountCheckMessage === 'No Account' && (
                    <StatusCard>
                        <IconCircle>$</IconCircle>
                        <StatusTitle>{translate('giving:admin.setupTitle')}</StatusTitle>
                        <StatusCopy>
                            {translate('giving:admin.setupAdminBody')}
                        </StatusCopy>
                        <StartGivingButton onClick={() => dispatch(setstartCreatingAccount(true))}>
                            {translate('giving:admin.startSetup')}
                        </StartGivingButton>
                    </StatusCard>
                )
            )}
        </SettingsMainContainer>
    )
}

const LoadingWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    width: 100%;
`

const StatusCard = styled.div`
    width: min(100%, 680px);
    margin: 20px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 30px;
    border-radius: 18px;
    background: #ffffff;
    box-shadow: 0 12px 35px rgba(15, 23, 42, 0.1);
`

const IconCircle = styled.div`
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(0, 180, 204, 0.12);
    color: var(--themeColor);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 28px;
`

const StatusTitle = styled.h2`
    margin: 0;
    color: var(--lightThemeFontColor);
    font-size: 24px;
    font-weight: 700;
`

const StatusCopy = styled.div`
    max-width: 520px;
    color: #6b7280;
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
`

const StartGivingButton = styled.button`
    min-height: 46px;
    padding: 0 22px;
    background-color: var(--themeColor);
    color: white;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 800;

    &:hover {
        background-color: var(--themeColorDark);
    }
`
